<div class="carregamento">
  <div class="container-loading">
    <div class="card-login">
      <div class="loading"></div>
      <span class="rotulo">{{ mensagem }}</span>
    </div>
  </div>
</div>